import Reveal from "@/components/base/Reveal";

const CART_ACTION = "https://nxhost.com.br/cliente/cart.php?a=add&domain=register";

export default function DomainCartForm() {
  return (
    <section id="pedidos-de-dominios" className="scroll-mt-24 bg-foreground-950 py-16 md:py-24">
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16">
          <Reveal>
            <div className="text-background-50">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-300">
                <i className="ri-shopping-cart-2-line" aria-hidden="true"></i>
                Pedidos de domínios
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight md:text-4xl">
                Já sabe o domínio? Vá direto para o carrinho.
              </h2>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-background-200">
                Digite o domínio que você quer registrar e finalize o pedido no carrinho de
                compras. É rápido, seguro e o registro fica no nome do titular informado.
              </p>

              <ul className="mt-6 flex flex-col gap-3">
                {[
                  "Registro no nome da sua empresa",
                  "Confirmação da disponibilidade",
                  "Apontamento para o seu site e e-mail",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-background-200">
                    <i className="ri-check-line mt-0.5 text-lg text-secondary-400" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-2xl border border-background-50/10 bg-background-50/5 p-6 backdrop-blur-sm md:p-8">
              <p className="text-sm font-semibold text-background-50">
                Registre o seu domínio agora
              </p>
              <p className="mt-1 text-xs text-background-400">
                Você será levado ao carrinho de compras da NXHOST para concluir o pedido.
              </p>

              <form method="post" action={CART_ACTION} className="mt-5 flex flex-col gap-3 sm:flex-row">
                <div className="flex flex-1 items-center overflow-hidden rounded-md border border-background-50/15 bg-background-50">
                  <span className="flex h-12 w-12 items-center justify-center text-foreground-400">
                    <i className="ri-global-line text-xl" aria-hidden="true"></i>
                  </span>
                  <input
                    type="text"
                    name="query"
                    size={20}
                    required
                    placeholder="suaempresa.com.br"
                    aria-label="Domínio que você quer registrar"
                    className="w-full border-0 bg-transparent py-3 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                  />
                </div>
                <button
                  type="submit"
                  className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-shopping-cart-2-line text-lg" aria-hidden="true"></i>
                  Registrar domínio
                </button>
              </form>

              <p className="mt-4 text-[11px] leading-relaxed text-background-500">
                Dica: informe o domínio completo, incluindo a extensão (por exemplo,
                suaempresa.com.br).
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}